module.exports = __webpack_public_path__ + "media/video1.68815f7d.mp4";